import React from 'react';
import pinguini from "../../assets/material-you/pinguino.gif";


const TestLayout4 = () => {
	return (
		<React.Fragment>
			<div style={{width: "100%", height: "100vh", display: "flex"}}>
				<img src={pinguini} alt={"pinguini"} style={{margin: "auto"}}/>
			</div>
		</React.Fragment>
	);
}

export default React.memo(TestLayout4);
